import { useTranslation } from 'react-i18next';

import { DataPanelAutoWrapInlineItem } from '@/ui';
import type { MedicData } from '@/signalr';
import { formatAsListOfStrings } from '../../model/formatters';

export type MedicDataPanelItemProps = {
  medicData: MedicData;
};

export function MedicDataPanelItem({ medicData }: MedicDataPanelItemProps) {
  const { t } = useTranslation();

  const values: string[] = [];
  if (medicData.diabetes) {
    values.push(t('Incident_InfoPanel_MedicData_Diabetes'));
  }
  if (medicData.heart) {
    values.push(t('Incident_InfoPanel_MedicData_HeartDefect'));
  }
  if (medicData.lungs) {
    values.push(t('Incident_InfoPanel_MedicData_LungDisease'));
  }
  if (medicData.speechDefect) {
    values.push(t('Incident_InfoPanel_MedicData_SpeechDefect'));
  }
  if (medicData.blind) {
    values.push(t('Incident_InfoPanel_MedicData_Blind'));
  }
  if (medicData.mentalDisorders) {
    values.push(t('Incident_InfoPanel_MedicData_MentalDisorders'));
  }
  if (medicData.epilepsy) {
    values.push(t('Incident_InfoPanel_MedicData_Epilepsy'));
  }

  const color = values.length > 0 ? 'critical' : 'none';

  return (
    <>
      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_MedicData')}
        value={formatAsListOfStrings(values)}
        color={color}
        showEmptyPlaceholder
      />

      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_AdditionalInformation')}
        value={medicData.note ?? undefined}
        showEmptyPlaceholder
        nonEmptyValueColor="critical"
      />

      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_RegularPrescription')}
        value={medicData.regularPrescription ?? undefined}
        showEmptyPlaceholder
        nonEmptyValueColor="critical"
      />

      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_NextOfKinNote')}
        value={medicData.nextOfKinNote ?? undefined}
        showEmptyPlaceholder
      />
    </>
  );
}
